import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideTrendingUp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M16 7h6v6" />
      <path d="m22 7-8.5 8.5-5-5L2 17" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideTrendingUp);
const Memo = memo(ForwardRef);
export default Memo;
